module.exports = __webpack_public_path__ + "static/media/addr_label_icon_disabled.d2ecdc65.svg";